import l10n from '../l10n/localization';

export default {
    /*value: {
        presence: {
            message: l10n.validation.required,
        },
    },*/
    quantity: {
        presence: {
            message: l10n.validation.required,
        },
    },
    commodity: {
        presence: {
            message: l10n.validation.required,
        },
    }
};



// WEBPACK FOOTER //
// ./src/validation/cargo.js